import { useForm } from "@inertiajs/vue3";
import { flatten } from "lodash";
import { useAPIForm } from "@/Tailwind/Mixins/useAPIForm";

export function useFormSetup() {
    const mapDetailsToForm = (fields, details, tabs, useApi = false) => {
        const panelFields = tabs?.map((tab) => flatten(tab.fields) ?? []);

        const allFields = tabs?.length ? flatten(panelFields) : fields;

        // Setting the form keys dynamically
        // We're also applying the default value if it exists in details
        const parsedFields = allFields.reduce((fields, field) => {
            fields[field.key] = details?.[field.key] ?? field.default ?? null;

            mapSubFields(fields, field, details);

            return fields;
        }, {});

        return useApi ? useAPIForm(parsedFields) : useForm(parsedFields);
    };

    const mapSubFields = (fields, field, details) => {
        if (field.fields?.length) {
            field.fields.forEach((subField) => {
                fields[subField.key] =
                    details?.[subField.key] ?? subField.default ?? null;

                mapSubFields(fields, subField, details);
            });
        }
    };

    return {
        mapDetailsToForm,
    };
}
